import { parseErrors } from 'lib/api-utils'
import * as api from '../api'

export const shareByEmail = (values) => {
  return function (dispatch) {
    return api
      .shareByEmail(values)
      .catch((resp) => Promise.reject(parseErrors(resp)))
  }
}
